import React, { useEffect, useRef, useState } from "react";
import { pageClass, pageHeader } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { getCallLogsAPI, getLeadUserHistoryAPI } from "../API/Api";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import moment from "moment";
import usePaginatedData from "../Components/Utils/UsePagination";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { openModal } from "../Redux/Slice/LoginSlice";
import ModifyCallTimeModal from "../Components/Modals/ModifyCallTimeModal";
import { IconChevronLeft, IconPhone } from "@tabler/icons-react";
import { LeadStatusStyles } from "../Components/Utils/StaticData";

export default function TeamLeadsDetails() {
  const location = useLocation();
  const { register } = useForm();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const LeadsData = location.state?.leadData || {};
  const isFirstRender = useRef(true);
  const [userHistory, setUserHistory] = useState([]);
  const filterTimeout = useRef();
  const themeColor = useThemeColor();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialFilterState = {
    p: 1,
    leadId: LeadsData._id,
  };

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });

  const {
    filterData: CallLogData,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
  } = usePaginatedData(1, 50, getCallLogsAPI, filterObject);

  const handleNavigate = () => {
  if (location.state?.from === "totalLeads") {
    navigate("/total-leads", { 
      state: { 
        restorePage: location.state?.fromPage, 
        title: location.state?.title,
        from: location.state?.origin,
        restoreRecords: location.state?.restoreRecords
      } 
    });
  } else if(location.state?.from === "Lead2"){
    navigate("/lead2", { 
      state: { 
        restorePage: location.state?.fromPage,
        restoreRecords: location.state?.restoreRecords
      } 
    });
  } else if(location.state?.from === "Lead1"){
    navigate("/lead1", { 
      state: { 
        restorePage: location.state?.fromPage, 
        restoreRecords: location.state?.restoreRecords
      } 
    });
  } else if (location.state?.from === "dashboard") {
      navigate("/");
    }
  else{
     navigate("/leads-groups", { 
      state: { 
        restorePage: location.state?.fromPage, 
        restoreRecords: location.state?.restoreRecords
      } 
    });
  }
};

  const filterSubmit = async (data) => {    
    const payload = {
      ...filterObject,
      p: pageNo,
      leadId: LeadsData._id
    };
    setFilterObject(payload);
  };
  const fetchLeadsHistory = async (id) => {
    try {
      const response = await getLeadUserHistoryAPI(id);
      setUserHistory(response?.data);
    } catch (error) {
      console.log("Error in fetching leads history", error);
    }
  };

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
    fetchLeadsHistory(LeadsData._id);
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; 
      return;
    }
    filterRecords();
  }, [filterObject]);

  const tableColumns = [
    {
      field: "name",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const firstName = row?.userId?.first_name || "----";
        const lastName = row?.userId?.last_name || "----";
        const fullName = (firstName && lastName) ? `${firstName} ${lastName}` : firstName || lastName || "-----";
        return <h6>{fullName}</h6>;
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => <h6>{row?.userId?.email ? row?.userId?.email : "--"}</h6>,
    },
    {
      field: "call_start",
      header: "Call Start",
      style: true,
      body: (row) => (
        <h6>
          {row?.callStart ? moment(row?.callStart).format("DD-MM-YYYY hh:mm:ss A") : "---"}
        </h6>
      ),
    },
    {
      field: "Call_End",
      header: "Call End",
      style: true,
      body: (row) => (
        <h6>
          {row?.callEnd ? moment(row?.callEnd).format("DD-MM-YYYY hh:mm:ss A") : "---"}
        </h6>
      ),
    },
    {
      field: "follow_date",
      header: "Follow Date",
      style: true,
      body: (row) => <h6>{row?.followDate ? moment(row?.followDate).format("DD-MM-YYYY") : "--"}</h6>,
    },
    {
      field: "follow_time",
      header: "Follow Time",
      style: true,
      body: (row) => <h6>{row?.followTime ? row?.followTime : "--"}</h6>,
    },
    {
      field: "lead_status",
      header: "Lead Status",
      style: true,
      body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />,
    },
    {
      field: "Sub_lead_status",
      header: "Sub Lead Status",
      style: true,
      body: (row) => <h6>{row?.subLeadStatus ? row?.subLeadStatus : "--"}</h6>,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6>{row?.remark ? row?.remark : "--"}</h6>,
    },
  ];

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="mb-[20px] rounded-[4px] cursor-pointer w-[56px] h-[48px] bg-[var(--bg-base-color)] flex items-center justify-center">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNavigate();
              }}
            >
              <IconChevronLeft stroke={1.5} size={23} color="#FFFFFF" />
            </button>
          </div>
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 xl:w-full min-w-[305px] lg:w-full md:w-full sm:w-full overflow-hidden">
            <div className="bg-[#F5F5F5] p-4 m-0 min-w-[50%] flex-wrap sm:mt-0 sm:m-5 rounded-xl">
              <h1 className={`${pageHeader} text-black font-bold pb-2 sm:pb-4 text-[24px] sm:text-[32]`}>
                Leads Details
              </h1>
              <div className="grid grid-cols-2 gap-2 sm:gap-0 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2">
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Name
                  </p>
                  <p className="capitalize font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.firstName || "-----"}{" "}{LeadsData?.lastName || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Email
                  </p>
                  <p className="capitalize  font-[500] text-[#52525B] text-[16px] break-words">
                    {LeadsData?.email || "-----"}
                  </p>
                </div>

                <div className="  p-2 sm:p-4 rounded-xl ">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Phone No
                  </p>
                  <p className="capitalize font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.phoneNumber || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl ">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Alternate No
                  </p>
                  <p className="capitalize font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.alternateNumber || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Lead Source
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.leadSource || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Pincode
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.pincode || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    City
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.city || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    State
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.state || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Product
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.product || "-----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Remark
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {LeadsData?.remark || "----"}
                  </p>
                </div>
                <div className="  p-2 sm:p-4 rounded-xl">
                  <p className="capitalize font-semibold text-[#52525B] text-[18px]">
                    Created At
                  </p>
                  <p className="capitalize  font-[500]  text-[#52525B] text-[16px]">
                    {moment(LeadsData?.createdAt).format("DD-MM-YYYY")|| "-----"}
                  </p>
                </div>
              </div>
            </div>
              <div className="sm:mt-0 sm:mr-5 sm:mb-5 sm:ml-5 bg-[#F5F5F5] p-4 min-w-[50%] min-h-[100%] flex-wrap rounded-xl overflow-y-auto scrollbar-hide">
                  <div className="flex items-start justify-between">
                    <div>
                    <h1 className={`${pageHeader} pb-1 text-black font-bold text-[24px] sm:text-[25px]`}>
                      Current Assign
                    </h1>
                    <p className="font-[500] text-[16px] text-[#52525B]">
                      To - {userHistory?.assigned_to?.first_name || "----"}{" "}
                      {userHistory?.assigned_to?.last_name || "----"}
                    </p>
                    </div>
                    <div>
                      {userHistory?.assigned_to?.first_name === userDetails?.first_name && (
                        <div className="flex justify-center">
                              <button
                                  onClick={() =>
                                    dispatch(
                                      openModal({
                                        isOpenModal: true,
                                        modalData: { rowdata: LeadsData },
                                      })
                                    )
                                  }
                                  className="flex items-center justify-center w-[133px] h-[48px] bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors cursor-pointer gap-2"
                              >
                                <IconPhone stroke={1.5} size={20}  color="#FFFFFF" />
                                <span className="font-[400] text-[16px]">Call Now</span>
                              </button>
                        </div>
                      )}
                    </div>
                  </div>
                <h1
                  className={`${pageHeader} pb-1 text-black font-bold text-[24px] sm:text-[25px] mt-2`}
                >
                  Previous Assign
                </h1>
                <p className="font-[500] text-[16px] text-[#52525B]">To</p>
                <div className="grid grid-cols-1  xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2">
                  {userHistory?.previous_assigned_to?.length > 0 ? (
                    userHistory.previous_assigned_to?.map((user, index) => (
                      <div key={index} className="p-4 rounded-xl">
                        <p className="capitalize font-[500] text-[16px] text-[#52525B]">
                          {user?.index}.{" "}
                          {user?.assignedUserId?.first_name || "----"}{" "}
                          {user?.assignedUserId?.last_name || "----"}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p className="font-[500] text-[16px] text-[#52525B]">No previous assigned users history</p>
                  )}
                </div>
              </div>
          </div>

          <div className="p-2 m-1 my-2 min-w-[305px] sm:mt-0">
            <div className="bg-[#FFFFFF] rounded-xl">
              <h1 className={`${pageHeader} text-black font-bold pb-2 text-[27px] sm:text-[28px]`}>
                Call Logs
              </h1>
              <Table
    columns={tableColumns}
    data={CallLogData}
    paginatorCheck={true}
    register={register}
  />
            </div>
          </div>
        </div>
      </div>
      <ModifyCallTimeModal edit={true}  filterRecords={() => filterRecords(true)} hideTrigger={true} />
    </>
  );
}
